/* Merry Clogz theme scripts */
(function(){
  /* countdown to the Christmas order cutoff; after it, the bar switches to the made-to-order line */
  document.querySelectorAll('[data-mc-countdown]').forEach(function(el){
    var end = new Date(el.getAttribute('data-mc-countdown')).getTime();
    var out = el.querySelector('b'), label = el.querySelector('[data-mc-countdown-text]');
    var after = el.getAttribute('data-mc-after'), until = el.getAttribute('data-mc-after-until'), fin = el.getAttribute('data-mc-final');
    var timer;
    function tick(){
      var now = Date.now(), d = end - now;
      if(d<=0){
        if(out){ out.hidden = true; }
        var u = until ? new Date(until).getTime() : 0;
        var txt = (u && now > u) ? (fin || after) : (after || fin);
        if(label && txt){ label.textContent = txt; }
        if(timer){ clearInterval(timer); }
        return;
      }
      var days=Math.floor(d/864e5), h=Math.floor(d%864e5/36e5), m=Math.floor(d%36e5/6e4), s=Math.floor(d%6e4/1e3);
      out.textContent = (days>0? days+'d ':'') + String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(s).padStart(2,'0')+'s';
    }
    tick(); timer = setInterval(tick,1000);
  });
  /* bundle tiers on the product page: sets the quantity input in the product form */
  document.querySelectorAll('[data-mc-tiers]').forEach(function(box){
    var form = box.closest('.product') ? box.closest('.product').querySelector('form[action*="/cart/add"]') : document.querySelector('form[action*="/cart/add"]');
    box.querySelectorAll('.mc-tier').forEach(function(tier){
      tier.addEventListener('click', function(){
        box.querySelectorAll('.mc-tier').forEach(function(t){ t.classList.remove('mc-tier--on'); t.querySelector('input').checked=false; });
        tier.classList.add('mc-tier--on'); tier.querySelector('input').checked=true;
        var q = parseInt(tier.getAttribute('data-qty'),10)||1;
        var qty = form && form.querySelector('input[name="quantity"]'); if(qty){ qty.value=q; qty.dispatchEvent(new Event('change',{bubbles:true})); }
        var hidden = document.querySelector('[data-mc-qty-mirror]'); if(hidden){ hidden.value=q; }
      });
    });
  });
  /* club opt-in: adds the Club membership (with its selling plan) as its own line when the box is ticked, and removes it when unticked */
  var optin = document.querySelector('[data-mc-club-optin]');
  if(optin){
    var cb = optin.querySelector('input[type="checkbox"]');
    var variant = optin.getAttribute('data-variant'), plan = optin.getAttribute('data-plan');
    cb.checked = false; /* never pre-checked */
    cb.addEventListener('change', function(){
      if(cb.checked){
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,selling_plan:Number(plan)}]})})
          .then(function(){ document.dispatchEvent(new CustomEvent('mc:cart:updated')); });
      } else {
        fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
          var line = c.items.find(function(i){ return String(i.variant_id)===String(variant); });
          if(line){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})}); }
        }).then(function(){ document.dispatchEvent(new CustomEvent('mc:cart:updated')); });
      }
    });
  }
  /* arrival window: made to order, today + min..max weeks; plus the Christmas cutoff note */
  document.querySelectorAll('[data-mc-delivery]').forEach(function(el){
    var minW = parseInt(el.getAttribute('data-min'),10)||6, maxW = parseInt(el.getAttribute('data-max'),10)||8;
    var now = new Date(), a = new Date(now), b = new Date(now);
    a.setDate(a.getDate()+minW*7); b.setDate(b.getDate()+maxW*7);
    function f(d, month){ return d.toLocaleDateString(undefined, month ? {month:'short',day:'numeric'} : {day:'numeric'}); }
    var out = el.querySelector('b');
    if(out){ out.textContent = f(a,true)+' to '+f(b, a.getMonth()!==b.getMonth()); }
    var note = el.parentNode ? el.parentNode.querySelector('[data-mc-delivery-note]') : null;
    var cutoff = el.getAttribute('data-cutoff'), xmas = el.getAttribute('data-christmas');
    if(note && cutoff){
      var c = new Date(cutoff).getTime(), x = xmas ? new Date(xmas).getTime() : 0, t = now.getTime();
      if(t <= c){ note.textContent = 'Order by '+new Date(cutoff).toLocaleDateString(undefined,{month:'long',day:'numeric'})+' and they are under the tree on December 24.'; note.hidden = false; }
      else if(x && t < x){ note.textContent = 'Orders placed now arrive after Christmas.'; note.hidden = false; }
    }
  });
})();
